import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../components/content/Login.vue')
      },
      {
            path: '/',
            name: 'Welcome',
            component: () => import('../components/content/ImagesPage.vue')
        },
        {
            path: '/collections/:clientId',
            name: 'CollectionsPage',
            props: true,
            component: () => import('@/components/content/CollectionsPage.vue')
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: () => import('../components/content/AMDashboardPage.vue')
        },
        {
            path: '/images-page/:clientId?',
            name: 'imagesPage',
            props: true,
            component: () => import('../components/content/ImagesPage.vue')
        },
        {
            path: '/single-collection/:clientId?/:collectionId?',
            name: 'singleCollection',
            props: true,
            component: () => import('../components/content/ImagesPage.vue')
        },
        // {
        //     path: '/single-collection/:clientId?/:collectionId?',
        //     name: 'singleCollection',
        //     props: true,
        //     component: () => import('../components/content/SingleCollectionPage.vue')
        // },
    ]
})
